import React from 'react';

import { useGetJournalEventsListQuery } from '@entities/eventJournal/api/hooks';
import { useNuqsQueryState } from '@shared/hooks';
import { FilterContainer, Icon } from '@shared/ui';
import {
    eventJournalModalExport,
    eventJournalModalModeQuery,
} from '@widgets/EventJournal/model/consts';

import { useJournalExport } from '../lib/hooks/useJournalExport';

import cls from '@features/JournalSortFilter/ui/JournalSortFilter.module.css';

export const JournalExport = () => {
    const { t } = useJournalExport();

    const { setState: setModalMode } = useNuqsQueryState(eventJournalModalModeQuery);
    const handleCreateEventBtn = async () => {
        void setModalMode(eventJournalModalExport);
    };

    const { data } = useGetJournalEventsListQuery();

    return (
        <FilterContainer isDisabled={!data?.length} onClick={handleCreateEventBtn}>
            <Icon iconName="download" height={14} width={14} color="currentColor" />
            <span className={cls.SortTitle}>{t('JournalEvents.Filters.Export')}</span>
        </FilterContainer>
    );
};
